module.exports = __webpack_public_path__ + "static/media/25542384_1703511149724069_121072645726059668_o.55fe8fb1.jpg";